/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-api
 * crm-screener-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { OrganizationStateType } from './OrganizationStateType';
import {
    OrganizationStateTypeFromJSON,
    OrganizationStateTypeFromJSONTyped,
    OrganizationStateTypeToJSON,
    OrganizationStateTypeToJSONTyped,
} from './OrganizationStateType';

/**
 * 
 * @export
 * @interface OrganizationStateTownSwitchTypeRequest
 */
export interface OrganizationStateTownSwitchTypeRequest {
    /**
     * 
     */
    type?: OrganizationStateType;
}



/**
 * Check if a given object implements the OrganizationStateTownSwitchTypeRequest interface.
 */
export function instanceOfOrganizationStateTownSwitchTypeRequest(value: object): value is OrganizationStateTownSwitchTypeRequest {
    return true;
}

export function OrganizationStateTownSwitchTypeRequestFromJSON(json: any): OrganizationStateTownSwitchTypeRequest {
    return OrganizationStateTownSwitchTypeRequestFromJSONTyped(json, false);
}

export function OrganizationStateTownSwitchTypeRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): OrganizationStateTownSwitchTypeRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'type': json['type'] == null ? undefined : OrganizationStateTypeFromJSON(json['type']),
    };
}

export function OrganizationStateTownSwitchTypeRequestToJSON(json: any): OrganizationStateTownSwitchTypeRequest {
    return OrganizationStateTownSwitchTypeRequestToJSONTyped(json, false);
}

export function OrganizationStateTownSwitchTypeRequestToJSONTyped(value?: OrganizationStateTownSwitchTypeRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'type': OrganizationStateTypeToJSON(value['type']),
    };
}

